import cls from 'classnames';
import React from 'react';

const ViewContent = ({ text, className }) => <div className={cls('text-sm text-gray-900', className)}>{text}</div>;

export default ViewContent;
